<template>
    <LayoutDashboard title="Transferências de Estoque">
        <v-card outlined>
            <v-card-title>
                <v-btn color="primary" @click="$router.push({name:'produtos'})" outlined>Voltar</v-btn>
                <v-btn color="primary" @click="cadastrarTransferenciaEstoque(true)" outlined class="ml-2">Nova Transferência</v-btn>
                <v-spacer></v-spacer>
                <v-text-field outlined dense v-model="search" append-icon="search" label="Pesquisar" single-line
                    hide-details>
                </v-text-field>
            </v-card-title>
            <v-card-text>
                <v-data-table :headers="headers" :items="getTransferenciasEstoques" :search="search" dense>
                    <template v-slot:item.action="{ item }">
                        <v-btn color="primary" outlined small @click="visualizarTransferenciaEstoque(item)">Visualizar</v-btn>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <ModalVisualizar />
        <ModalTransferenciaEstoque />
    </LayoutDashboard>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import ModalVisualizar from '@/pages/estoque/transferencia/ModalVisualizar'
    import ModalTransferenciaEstoque from "@/pages/estoque/transferencia/ModalCadastro";
    
    export default {
        components: {
            ModalVisualizar,
            ModalTransferenciaEstoque
        },
        data() {
            return {
                search: '',
                headers: [
                    { text: '#', value: 'id', sortable: false },
                    { text: 'Estoque de Orgiem', align: 'left', sortable: false, value: 'estoque_origem.nome'},
                    { text: 'Estoque de Destino', align: 'left', sortable: false, value: 'estoque_destino.nome'},
                    { text: 'Funcionário', align: 'left', sortable: false, value: 'funcionario.nome'},
                    { text: 'Ações', value: 'action', sortable: false }
                ],
            }
        },
        computed: {
            ...mapGetters([
                'getTransferenciasEstoques'
            ])
        },
        methods: {
            ...mapActions([
                'visualizarTransferenciaEstoque',
                'listarTransferenciaEstoque',
                'cadastrarTransferenciaEstoque'
            ])
        },
        created(){
            this.listarTransferenciaEstoque()
        }
    }
</script>